import React from 'react';
import {Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';

const {text} = translations['pt-br'].privateFlow.therapyBooking.alerts.minimumInterval;

export function MinimumIntervalDescription() {
	return <Typography textAlign="center">{text}</Typography>;
}
